import { Button, Spinner } from 'components/Elements';
import { Notifications } from 'components/Notifications/Notifications';

import { AuthProvider } from 'lib/auth';
import { queryClient } from 'lib/react-query';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocationProvider } from './location';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div
      className="w-screen h-screen flex flex-col justify-center items-center px-6 text-center bg-white"
      role="alert"
    >
      <div className="max-w-md">
        <h2 className="text-xl font-bold text-gray-900">Something went wrong</h2>

        <p className="mt-3 text-gray-600 text-sm leading-relaxed">
          We ran into an unexpected issue while loading Dejunk. This can happen due to a temporary
          network or session problem.
        </p>

        <div className="mt-6 flex flex-col gap-3">
          <Button
            onClick={() => {
              resetErrorBoundary?.();
            }}
          >
            Try again
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              localStorage.clear();
              window.location.assign(window.location.origin);
            }}
          >
            Reset session
          </Button>
        </div>

        <p className="mt-6 text-xs text-gray-400">
          If this continues, check your internet connection or try again later.
        </p>
      </div>
    </div>
  );
};

export const AppProvider = ({ children }) => {
  return (
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
          <Spinner size="xl" />
        </div>
      }
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {process.env.NODE_ENV !== 'test' && <ReactQueryDevtools />}
            <Notifications />
            <AuthProvider>
              <LocationProvider>
                <Router>{children}</Router>
              </LocationProvider>
            </AuthProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
